let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("CxhW1")).then(() => parcelRequire('32UbK'));